export default __webpack_public_path__ + "static/media/netflix-icon.830da484.svg";